import { lazy } from 'react'
import { createRoot } from 'react-dom/client'
import { getUserFromToken } from './helpers/profile'


const App = lazy(() => import('./App'))

function ready(fn) {
  if (document.readyState != 'loading') {
    fn()
  } else {
    document.addEventListener('DOMContentLoaded', fn)
  }
}

ready(async () => {
  const root = createRoot(document.getElementById('root'))
  // "Bearer XXXXX"
  let storedToken = localStorage.getItem('token')
  const visitor = await getUserFromToken(storedToken)
  root.render(<App visitor={visitor} />)
})
